import type { ReactElement } from 'react';
import { DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface SuccessContentProps {
  onDone: () => void;
}

export function SuccessContent({ onDone }: SuccessContentProps): ReactElement {
  return (
    <>
      <div>
        <DialogTitle className="vtwo:text-2xl vtwo:font-bold">Upgrade request received</DialogTitle>
        <DialogDescription className="vtwo:mt-2">
          Our team will review your request and adjust your contract as soon as possible. In the
          meantime, you can continue setting up your website.
        </DialogDescription>
      </div>

      <hr className="vtwo:border-gray-200" />

      <Button
        size="xl"
        onClick={onDone}
        className="vtwo:w-full vtwo:bg-featured vtwo:hover:bg-featured-hover vtwo:rounded-full"
      >
        Continue setup
      </Button>
    </>
  );
}
